"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LegalPurposeSubCategory = void 0;
const type_utils_1 = require("@transcend-io/type-utils");
exports.LegalPurposeSubCategory = (0, type_utils_1.makeEnum)({
    /** Fallback sub purpose */
    Legal: 'LEGAL',
});
//# sourceMappingURL=legal.js.map